export default __webpack_public_path__ + "static/media/course detail.45156e6e.png";